import script from "./InstitutionsApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionsApplications.vue?vue&type=script&setup=true&lang=js"

import "./InstitutionsApplications.vue?vue&type=style&index=0&id=313bbf0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313bbf0a"]])

export default __exports__